import React, { useState } from "react";
import "./MessageA1RequestTrack.css";


import '../../../../src/assets/fonts/fontello/css/fontello.css';



const MessageA1RequestTrack = (props) => {
    const { item, handleClick, setTextOnClick } = props
    const [expandedCards, setExpandedCards] = useState({});
    let data = item?.text && JSON.parse(item?.text)
    console.log(data)
    const toggleDetails = (id) => {
        setExpandedCards((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const removeTime = (str) => {

        if (str === '') {
            return
        }
        let arr = str.split(',')
        if (arr.length > 0) {
            return `${arr[0]},${arr[1]}`
        }
        return ''

    }
    const Reopen = (req) => {
        handleClick(item?.code, JSON.stringify(req))
        setTextOnClick("Re Open")
    }

    const loadStepTwo = (status, date) => {
        switch (status) {
            case 'Closed':
                return (
                    <>
                        <div className="status-icon-container">
                            <span className="status-icon-success"></span>
                        </div>
                        <div className="status-req">In Progress</div>
                    </>
                );

            case 'Open':
                return (
                    <>
                        <div className="trackstatus-req">
                            <span className="trackborder-pending">
                                <span className="greenfill-pending"></span>
                            </span>
                        </div>
                        <div className="status-req">In Progress</div>
                    </>
                );
            case 'Delayed':
                return (
                    <>
                        <div className="trackstatus-req">
                            <span className="trackborder">
                                <span className="redfill"></span>
                            </span>

                        </div>
                        <div className="status-req">Due Date was</div>
                        <div>{removeTime(date)}</div>
                    </>
                );

            default:
                return null;
        }
    };

    const loadStepThree = (status, req) => {

        switch (status) {
            case 'Closed':
                return (
                    <>
                        <div className="status-icon-container">
                            <span className="status-icon-success"></span>
                        </div>
                        <div className="status-req">{status === "Closed" ? "Completed" : "Will be solved by"}</div>
                        <div>{status === "Closed" ? req?.completed : removeTime(req?.will_be_solved_by)}</div>
                    </>
                );

            case 'Open':
                return (
                    <>
                        <div className="trackstatus-req">
                            <span className="trackborder-not-picked">
                                <span className="greenfill-not-picked"></span>
                            </span>
                        </div>
                        <div className="status-req">{req.srStatus === "Closed" ? "Completed" : "Will be solved by"}</div>
                        <div>{status === "Closed" ? req?.completed : removeTime(req?.will_be_solved_by)}</div>
                    </>
                );
            case 'Delayed':
                return (
                    <>
                        <div className="trackstatus-req">
                            <span className="trackborder-pending">
                                <span className="greenfill-pending"></span>
                            </span>
                        </div>
                        <div className="status-req">Still In Progress</div>
                        {/* <div>{removeTime(req?.will_be_solved_by)}</div> */}
                    </>
                );

            default:
                return null;
        }
    };



    return (
        <div className="message-track-container">
            <div className="top-bar">

                <a href={data?.url} target="_blank" rel="noopener noreferrer">
                    <button className="view-all-button action-tab">View All</button>
                </a>
            </div>

            <div className="scroll-container">
                {data?.dataSr?.map((req) => (
                    <div className="card-container" key={req.request}>
                        {/* <div className="card-header">
                            <span className="status-badge">{req.srStatus}</span>
                        </div>

                        <div className="request-banner">Request {req.request}</div> */}
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>


                            <div className="request-banner">  <img style={{ marginRight: '8px', height: '20px', width: '20px' }} src={"https://qa-portal.tataplay.com/s3-api/v1/assets/icons/open-ticket.svg"} alt="req" />Request {req.request}</div>

                            <div style={{ backgroundColor: req?.srStatus === "Closed" ? 'rgb(192 192 192)' : "#7f00ff" }} className="card-header">
                                {req.srStatus}
                                {/* <span className="status-badge">{req.srStatus}</span> */}
                            </div>


                        </div>

                        <div className="request-card-body ">
                            <div style={{display :'flex' , justifyContent : 'flex-start' ,margin :'10px 2px 20px 2px'}}>{req?.srArea}</div>
                            <p className="due-date">
                                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <span>
                                        <strong>Created : </strong>
                                        <div>{req.created}</div>
                                    </span>
                                    |
                                    <span>
                                        {/* <strong>{req.srStatus === "Closed" ? "Closed" : "Will be solved By"} </strong> */}
                                        <strong>{req.srStatus === "Closed" ? "Closed" : req.srStatus === "Delayed" ? "Due Date was" : "Will be solved By"} </strong>
                                        <div>{req.srStatus === "Closed" ? req?.completed : req?.will_be_solved_by}</div>
                                    </span>
                                </div>

                            </p>
                            {req?.srStatus === 'Delayed' && <div style={{marginTop : '16px' ,marginBottom : '16px'}}> <img style={{ marginRight: '8px', height: '16px', width: '16px' }} src={"https://qa-portal.tataplay.com/s3-api/v1/assets/icons/warning-error.svg"} alt="req" />We’re sorry for the delay and inconvenience. We’re trying our best to fix the issue at the earliest.</div>}
                           
                            <button
                                className="toggle-button"
                                onClick={() => toggleDetails(req.request)}
                            >
                                {expandedCards[req.request] ? "View Less" : "View Details"}
                            </button>

                            {expandedCards[req.request] && (
                                <>
                                    
                                    <div className="support-box">
                                        <div className="support-icon">▶</div>
                                        <div>
                                            <strong>Tata Play Support</strong>
                                            <p style={{ marginTop: '4px' }}>{req.srStatus === "Closed" ? "Yay, your issue is been resloved!" : "Please give us sometime.. we’re working on the issue."}</p>
                                        </div>
                                    </div>

                                    <div className="timeline">
                                        {/* Step 1 */}
                                        <div className="step completed">
                                            <div className="status-icon-container">
                                                <span className="status-icon-success"></span>
                                            </div>
                                            <div className="status-req">Created</div>
                                            <div>{req.created}</div>
                                        </div>

                                        {/* Step 2 */}
                                        <div className={`step ${req.srStatus === "Closed" ? 'completed' : 'failed'}`}>

                                            {loadStepTwo(req?.srStatus, req?.will_be_solved_by)}

                                        </div>

                                        {/* Step 3 */}
                                        <div className={`step ${req.srStatus === "Closed" ? 'completed' : 'failed'}`}>
                                            {loadStepThree(req?.srStatus, req)}
                                            {/* {req.srStatus === "Closed" ? (
                                                <div className="status-icon-container">
                                                    <span className="status-icon-success"></span>
                                                </div>
                                            ) : (
                                                <div className="trackstatus-req">
                                                    <span className="trackborder-not-picked">
                                                        <span className="greenfill-not-picked"></span>
                                                    </span>
                                                </div>
                                            )} */}

                                        </div>
                                    </div>
                                    {req?.srReopen &&
                                        <div className="re-open-req">
                                            <div>Still facing issues? You can re-open the request. We’ll be happy to help you.</div>
                                            <div className="re-open-button action-tab"
                                                onClick={() => Reopen(req)}>Re-open</div>
                                        </div>}



                                </>
                            )}
                        </div>


                    </div>
                ))}
            </div>
        </div>
    );
};

export default MessageA1RequestTrack;
